import { render, staticRenderFns } from "./ShipStatus.vue?vue&type=template&id=09b1d446&scoped=true"
import script from "./ShipStatus.vue?vue&type=script&lang=ts"
export * from "./ShipStatus.vue?vue&type=script&lang=ts"
import style0 from "./ShipStatus.vue?vue&type=style&index=0&id=09b1d446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b1d446",
  null
  
)

export default component.exports